import React, { useState } from "react";
import { alpha, IconButton, Stack } from "@mui/material";
import LotsMapDialog from "../LotsMapDialog";
import { LocationAdd } from "iconsax-react";
import { blue } from "@mui/material/colors";
import { usePermissions } from "../../../hooks/permissions/usePermissions";

export default function LotsTableActions({ lot, fetchLots }) {
  const [openDialog, setOpenDialog] = useState(null);

  const { hasAllPermissions } = usePermissions();

  const handleDialogOpen = (dialogName) => {
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "4px",
      }}
    >
      <LotsMapDialog
        open={openDialog === "Map"}
        lot={lot}
        onClose={() => {
          handleDialogClose();
        }}
        fetchLots={fetchLots}
      />

      {hasAllPermissions(["lot_vw", "up_loc_b", 'vw_pel']) && (<IconButton
        size="small"
        color="primary"
        aria-label="add location"
        onClick={() => handleDialogOpen("Map")}
        style={{
          color: blue[400],
          backgroundColor: alpha(blue[500], 0.1),
        }}
      >
        <LocationAdd fontSize="small" />
      </IconButton>)}
    </Stack>
  );
}
